export async function startStatsigWebAnalytics(client, options = {}) {
    const { runStatsigAutoCapture } = await import("@statsig/web-analytics");
    runStatsigAutoCapture(client, {
        consoleLogAutoCaptureSettings: {
            enabled: true,
        },
        ...options,
    });
}
